import * as Icons from "heroicons-react";
import { signInUser } from "../../Utility/Auth";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
  useProductWisePurchaseQuery,
  useUserWiseSalesQuery,
} from "../../../services/reportsApi";
import { useWarehouseQuery } from "../../../services/warehouseApi";
import WareHouseDW from "../../Common/CustomSelect/WareHouseDW";
import SelectUser from "../../Common/CustomSelect/SelectUser";
import SelectProduct from "../../Common/CustomSelect/SearchProduct";
import SelectProductReport from "../../Common/CustomSelect/SelectProductReport";

const ProductWisePurchaseReport = () => {
  const auth = signInUser();

  const [warehouse, setWarehouse] = useState("allWh");
  const [productId, setProductId] = useState();

  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const { aamarId } = auth;
  const lang = useSelector((state) => state.languageReducer);
  const {
    data: salesData,
    isLoading,
    isError,
    error,
  } = useProductWisePurchaseQuery({
    startDate,
    endDate,
    warehouse,
    aamarId,
    productId,
  });

  // console.log("Product Wise Purchase Report Data:", salesData, productId);

  // fine warehouse Name
  const [whName, setWhName] = useState("All Warehouses");

  const { data: wh, refetch } = useWarehouseQuery(warehouse);

  // Call refetch only if user?.warehouse changes
  useEffect(() => {
    if (warehouse) {
      refetch();
    }
  }, [warehouse, refetch]);

  // Update warehouse name when data changes
  useEffect(() => {
    if (wh?.name) {
      setWhName(wh.name); // Directly set the name, no need for optional chaining here
    }
  }, [wh]);
  // console.log("Customer Wise Sales Report Data:", salesData);

  // Export CSV
  const handleExportCSV = () => {
    if (!salesData || salesData.length === 0) {
      alert("No data available for export.");
      return;
    }

    const start = new Date(startDate).toLocaleString();
    const end = new Date(endDate).toLocaleString();
    // const end = salesData[salesData.length - 1]?.createdAt;
    const generatedOn = new Date().toLocaleString();
    const generatedBy = auth?.name || "Aamar Dokan";

    const storeName =
      auth?.storeSettings?.storeName?.toUpperCase() || "Aamar Dokan";
    const warehouseName = whName;
    const reportTitle = "Product Wise Purchase Report";

    const headerInfo = [
      `,Store: ${storeName},,,,,Warehouse: ${warehouseName}`,
      `,Report: ${reportTitle},,,,,Date Range: ${start} to ${end}`,
      `,Generated On: ${generatedOn},,,,Generated By: ${generatedBy}`,
      "",
      "",
    ];

    const csvTableHeader = [
      "S/N",
    "GRN No",
    "PO No",
    "TPN No",
    "Date",
    "Supplier Name",
    "Product Name",
    "Article Code",
    "Warehouse",
    "TP",
    "Quantity",
    "Amount ",
    ].join(",");

    

    let totalQty = 0;
    let totalAmount = 0;

    const formatAmount = (amount) => `${parseFloat(amount || 0).toFixed(2)}`;


    const csvRows = salesData.map((item, index) => {
      const tp = parseFloat(item?.tp || 0);
      const qty = parseFloat(item?.qty || 0);
      const amount = parseFloat(item?.amount || 0);
  
      totalQty += qty;
      totalAmount += amount;
  
      return [
        index + 1,
        item?.grnNo || "-",
        item?.poNo || "-",
        item?.tpnNo || "-",
        new Date(item?.date).toLocaleDateString("en-GB"),
        item?.supplierName || "-",
        item?.productName || "-",
        item?.article_code || "-",
        item?.warehouse || "-",
        formatAmount(tp),
        qty,
        formatAmount(amount),
      ].join(",");
    });

  const summaryLabelRow = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "** TOTAL SUMMARY **",
  ].join(",");

  const summaryHeaderRow = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "Total Qty",
    "Total Amount",
  ].join(",");

  const summaryDataRow = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    totalQty,
    formatAmount(totalAmount),
  ].join(",");

  const csvContent = [
    ...headerInfo,
    csvTableHeader,
    ...csvRows,
    "",
    "",
    summaryLabelRow,
    summaryHeaderRow,
    summaryDataRow,
  ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ProductWisePurchaseReport.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  // export PDF
  const handleExportPDF = () => {
    const doc = new jsPDF("landscape");

    if (salesData?.length === 0) {
      alert("No sales data found.");
      return;
    }

    const options = { month: "numeric", day: "numeric", year: "numeric" };
    const formattedStart = new Date(startDate).toLocaleDateString(
      "en-US",
      options
    );
    const formattedEnd = new Date(endDate).toLocaleDateString("en-US", options);
    const reportGeneratedAt = new Date().toLocaleString();

    const storeName =
      auth?.storeSettings?.storeName?.toUpperCase() || "Aamar Dokan";
    const warehouseName = whName;
    const reportName = "Product Wise Purchase Report";

    // Title
    doc.setFontSize(16);
    doc.text(storeName, 140, 15, { align: "center" });

    doc.setFontSize(12);
    doc.text(reportName, 140, 22, { align: "center" });

    // Header info - Justify between
    doc.setFontSize(10);
    doc.text(`Store: ${storeName}`, 14, 28);
    doc.text(`Warehouse: ${warehouseName}`, 14, 33);
    doc.text(`Date: ${formattedStart} - ${formattedEnd}`, 14, 39);
    // doc.text(`Report: ${reportName}`, 140, 28, { align: "center" });
    doc.text(`Generated At: ${reportGeneratedAt}`, 280, 28, { align: "right" });
    doc.text(`Generated By: ${auth?.name}`, 280, 33, { align: "right" });

    // Table header
    const headers = [
      [
        "S/N",
        "GRN No",
        "PO No",
        "TPN No",
        "Date",
        "Supplier",
        "Product",
        "Article Code",
        "Warehouse",
        "TP",
        "Quantity",
        "Amount",
      ],
    ];
    const data = salesData.map((item, index) => [
      index + 1,
      item?.grnNo || "-",
      item?.poNo || "-",
      item?.tpnNo || "-",
      item?.date ? new Date(item.date).toLocaleDateString("en-GB") : "-",
      item?.supplierName || "-",
      item?.productName || "-",
      item?.article_code || "-",
      item?.warehouse || "-",
      formatAmount(item?.tp), // Format TP
      item?.qty || 0,
      formatAmount(item?.amount), // Format Amount
    ]);

    autoTable(doc, {
      head: headers,
      body: data,
      startY: 45,
      theme: "grid",
      styles: {
        fontSize: 9,
        halign: "center",
      },
      headStyles: {
        fillColor: [34, 112, 147],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
    });

    // === Summary Box ===
    const finalY = doc.lastAutoTable.finalY + 10;
    const lineHeight = 6;  // Reduced line height to make the box smaller
    const boxHeight = 4 * lineHeight + 10; // Reduced height to fit only 4 lines of summary
    const boxWidth = 80; // Reduced width for a smaller box

    const pageWidth = doc.internal.pageSize.getWidth();
    const boxX = pageWidth - boxWidth - 15;
    const boxY = finalY;

    // Draw dotted border
    doc.setLineDashPattern([1, 1], 0);
    doc.rect(boxX, boxY, boxWidth, boxHeight);
    doc.setLineDashPattern([], 0); // reset to solid

    let y = boxY + 10;
    const labelX = boxX + 5;
    const valueX = boxX + boxWidth - 5;
    doc.setFontSize(9);

    // Summaries
    const totalQty = sumField(salesData, "qty");
    const totalAmount = sumField(salesData, "amount");

    doc.text("Total Quantity:", labelX, y);
    doc.text(formatAmount(totalQty), valueX, y, { align: "right" });

    y += lineHeight;
    doc.text("Total Amount:", labelX, y);
    doc.text(formatAmount(totalAmount), valueX, y, { align: "right" });

    // Save the PDF
    doc.save("Product_wise_Purchase_Reports.pdf");
  };

  // Utility function to format amounts with commas and no decimals
  const formatAmount = (amount) => {
    if (amount == null) return "-";
    return Number(amount).toLocaleString(); // Adding commas for thousands
  };

  // Utility to sum values from objects
  const sumField = (data, field) =>
    data
      .reduce((acc, item) => acc + (parseFloat(item[field]) || 0), 0)
      .toFixed(2);

  //warehouse
  const handleOnchangeWareHouseFrom = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
  };

  return (
    <div>
      <div>
        <h2 className="mb-3">
          <Icons.ShoppingCartOutline size={35} /> Product Wise Purchase Report
        </h2>
      </div>

      <div
        className="mt-3 w-40 p-3"
        style={{ backgroundColor: "#f1f3f5", borderRadius: "8px" }}
      >
        <div className="d-flex mt-2 mb-2 align-items-center justify-content-center gap-2">
          <DatePicker
            selected={new Date(startDate)}
            className="form-control w-100"
            onChange={(date) =>
              setStartDate(format(new Date(date), "MM-dd-yyyy"))
            }
          />
          <DatePicker
            selected={new Date(endDate)}
            className="form-control me-4"
            onChange={(date) =>
              setEndDate(format(new Date(date), "MM-dd-yyyy"))
            }
          />
        </div>

        <div className="">
          {auth?.type === "admin" && (
            <div className="my-3">
              <WareHouseDW
                id="warehouse"
                name="warehouse"
                handleOnChange={handleOnchangeWareHouseFrom}
                className="form-control"
              />
            </div>
          )}
          <SelectProductReport aamarId={aamarId} onUserSelect={setProductId} />
        </div>

        <div className="d-flex gap-3 justify-content-center align-items-center text-center">
          {/* Download CSV Button */}
          <button
            className="btn btn-dark w-100 mt-3"
            style={{ borderRadius: "5px" }}
            onClick={handleExportCSV}
          >
            <Icons.DownloadOutline size={22} /> Download CSV
          </button>

          {/* Download PDF Button */}
          <button
            className="btn btn-dark w-100 mt-3"
            style={{ borderRadius: "5px" }}
            onClick={handleExportPDF}
          >
            <Icons.DocumentOutline size={22} /> Download PDF
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductWisePurchaseReport;
